const languages = ['en', 'de', 'fr', 'it', 'es'];

/**
 * Generates a self-referencing canonical URL based on the current router state.
 * Handles locale prefixes and trailing slashes according to project configuration.
 *
 * @param router - The Next.js router object from useRouter()
 * @returns The fully qualified canonical URL
 */
const getCanonicalUrl = (router: any): string => {
  const baseUrl = 'https://spiritory.com';
  const currentLocale = router.locale || 'en';
  const localePrefix = currentLocale === 'en' ? '' : `/${currentLocale}`;

  // Get path without query string
  let asPath = router.asPath || '/';
  let cleanPath = asPath.split('?')[0];

  // In Next.js Pages Router, asPath often includes the locale prefix (e.g., /de/sku-name).
  // We need to strip it to generate the cleanPath relative to the root.
  for (const lang of languages) {
    if (cleanPath.startsWith(`/${lang}/`)) {
      cleanPath = cleanPath.substring(lang.length + 1);
      break;
    } else if (cleanPath === `/${lang}`) {
      cleanPath = '';
      break;
    }
  }

  // Ensure cleanPath starts with a forward slash if not empty
  if (cleanPath !== '' && !cleanPath.startsWith('/')) {
    cleanPath = '/' + cleanPath;
  }

  // Remove single trailing slash if it's the root relative to locale
  if (cleanPath === '/') {
    cleanPath = '';
  }

  let finalUrl = `${baseUrl}${localePrefix}${cleanPath}`;

  return finalUrl;
};

export default getCanonicalUrl;
